import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useForm } from '@/util/useForm';
import { message } from 'ant-design-vue';
import { addCustomerTags } from '@/api/operation/customer';
import router from '@/router';
import { format } from 'echarts';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCustomerTag',
  setup(__props) {

const form = useForm();
const pitch = ref<any[]>(['A']); // 多选 A、B、C、D 默认选中第一个
const tag_type = ref<number>(1); // 1 手动标签 2 自动标签
const theA = computed(() => {
  return pitch.value.includes('A') && true;
});

function onSubmit() {
  const send_data = {
    name: '',
    type: 1,
    rule: {},
  };
  form.value.validateFields(async (errors, values) => {
    if (!errors) {
      if (pitch.value.length == 0) {
        return message.error('至少选择一项条件');
      }
      if (tag_type.value === 1) {
        send_data['name'] = values.tag_name;
        send_data['type'] = tag_type.value;
      } else {
        send_data['name'] = values.tag_name;

        send_data['type'] = tag_type.value;
        pitch.value.includes('A')
          ? (send_data.rule['last_consumption_days'] = values.time)
          : undefined;
        pitch.value.includes('B')
          ? (send_data.rule['order_count_range'] = [values.min_time, values.max_time].sort(
              (a, b) => a - b
            ))
          : undefined;
        pitch.value.includes('C')
          ? (send_data.rule['consumption_amount_range'] = [
              Math.round(values.min_money * 100),
              Math.round(values.max_money * 100),
            ].sort((a, b) => a - b))
          : undefined;
        pitch.value.includes('D')
          ? (send_data.rule['order_avg_price_range'] = [
              Math.round(values.min_average * 100),
              Math.round(values.max_average * 100),
            ].sort((a, b) => a - b))
          : undefined;
      }
      const res = await addCustomerTags(send_data);
      if (res && res.status !== 200) {
        message.error((res as any).message);
        return;
      }
      message.success('新增成功');
      router.push('/customer/customer-tag');
    } else {
      return message.error('请检查必填项');
    }
  });
}
// 更新勾选值
function checkChange(checkedValue) {
  if (checkedValue.length == 0) {
    pitch.value.push('A');
  }
  pitch.value = [...checkedValue];
}

return { __sfc: true,form, pitch, tag_type, theA, onSubmit, checkChange }
}

})